import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CameraService } from '../../shared/services/camera.service';
import { catchError, finalize, Observable, of, Subscription } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'avs-video-player',
  standalone: false,
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.css'
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  @Input() routeStationGuid!: string;
  @Input() recordingId!: string;

  videoUrl?: SafeUrl;
  isLoading = false;
  error?: string;

  private sub?: Subscription;

  constructor(private cameraService: CameraService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.loadVideo();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();

  }

  loadVideo() {
    if (!this.routeStationGuid || !this.recordingId) {
      this.error = 'Missing parameters';
      return;
    }

    this.isLoading = true;
    this.error = undefined;

    this.sub = this.cameraService
      .getRecording(this.routeStationGuid, this.recordingId)
      .pipe(
        finalize(() => (this.isLoading = false)),
        catchError(err => {
          this.error = err.message || 'Failed to load video';
          return of(new Blob());
        })
      )
      .subscribe(blob => {
/*         console.log('Blob size:', blob.size);
 */        if (blob.size === 0) {
          this.error = 'Empty video file';
          return;
        }
        const url = URL.createObjectURL(blob);
        // In eine SafeUrl umwandeln
        this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(url);
      });
  }

  onVideoError(event: any) {
    this.error = 'Video playback error';
  }

}